export const izradi_vlastitu_odluku = {
    templateId: 49,
    category: 12,
    templateTitle: "Izradi vlastitu odluku",
    templateDescription: `<p>Pomoću ovog dokumenta možete samostalno kreirati vlastitu odluku.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Ovim dokumentom kreirate vlastite predloške</p>
    <br>
    <p>U točku I. upisujete željeni tekst te potom dodajete preostale točke i upisujete njihov sadržaj.</p>
    <br>
  `,
    sides: [
        {
            prefix: '',
            signature: 'Potpis:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
        }
    ],

    headline: '(u daljnjem tekstu:__________________________), donosi sljedeću',
    title: 'ODLUKU',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ovdje, te nadalje u ostale točke (koje dodajete samostalno) upisujete tekst po želji...',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },     
           {
            static: true,
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: false,
                    editable: true,
                    content: 'Dostaviti:',
                    help: 'Po želji, slobodno upišite kome želite dostaviti odluku.'
                }
            ]
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/49_izradi_vlastitu_odluku.ts